<template>
  <div class="mobile">
    <MobileTop class="mob-index" id="mob-index" />
    <div class="mobile__dvd">
      <a
        href="https://www.amazon.de/gp/video/detail/B09SSKWTTX/ref=atv_dp_share_cu_r"
        target="_blank"
        ><img src="@/assets/images/top/amazon.png" alt=""
      /></a>
      <a
        href="https://tv.apple.com/de/movie/wagner-bayreuth-und-der-rest-der-welt/umc.cmc.1f3iciwad5m9mbn5sywte6qgt?itsct=tv_box_link&itscg=30200"
        target="_blank"
        ><img src="@/assets/images/top/itunes.png" alt=""
      /></a>
      <a
        href="https://naxosdirekt.de/items/wagner-bayreuth-und-der-rest-der-welt-576854"
        target="_blank"
        ><img src="@/assets/images/top/naxos.png" alt=""
      /></a>
    </div>
    <div class="sizzle-1">
      <MobileTrailer :youtube="$config.youtube" color="white" />
    </div>

    <!-- <div class="stoerer-wrapper">
      <a
        href="mailto:wagner@fwem.de?subject=Wagner%20-%20Anfrage%20für%20Screenings%20"
        class="mobile__stoerer"
        :class="$mq"
      >
        <img src="@/assets/images/allgemein/stoerer.png" alt="" />
      </a>
      <a
        href="downloads/Wagner_Kinotour.pdf"
        target="_blank"
        class="mobile__stoerer"
        :class="$mq"
      >
        <img src="@/assets/images/allgemein/stoerer2.png" alt="" />
      </a>
      <a
        href="downloads/Wagner_Kinoliste.pdf"
        target="_blank"
        class="mobile__stoerer"
        :class="$mq"
      >
        <img src="@/assets/images/allgemein/stoerer3.png" alt="" />
      </a>
    </div> -->
    <div class="mob-cite" :class="$mq">
      <div class="bild-cite">
        <img src="@/assets/images/allgemein/cite_sign.png" alt="" />
      </div>
      <div class="text">
        <BaseCitesFade class="" :class="$mq" />
      </div>
    </div>
    <Smalltext />

    <div class="mob-card-headline">
      <div class="text">Inhalt</div>
    </div>

    <!-- Inhalt -->
    <div id="mob-inhalt">
      <MobileExpandableCard
        class="mob-inhalt"
        image="card_inhalt.jpg"
        cardBg="white"
        closeColor="white"
        btnTopAlign="left"
        btnTopColor="var(--clr-red)"
        btnTopBg="transparent"
        btnBottomColor="var(--clr-red)"
        btnBottomBg="transparent"
        cardBorderRadius="0px"
        imageAlign="center"
      >
        <!-- H1 Headline -->
        <!-- <template v-slot:headline> Inhalt </template> -->
        <!-- Teaser -->
        <template v-slot:teaser>
          <div v-html="$texte.inhalt.teaser"></div>
        </template>
        <!-- Hidden Maincontent -->
        <div v-html="$texte.inhalt.text"></div>
      </MobileExpandableCard>
    </div>
    <!-- Ende -->

    <div class="mob-fotos">
      <img src="@/assets/images/mobile/fotos.jpg" alt="" />
    </div>

    <div class="mob-card-headline">
      <div class="text">Team</div>
    </div>

    <!-- Team -->
    <div id="mob-team">
      <MobileExpandableCard
        class="mob-team"
        image="card_crew.jpg"
        cardBg="white"
        closeColor="white"
        btnTopAlign="left"
        btnTopColor="var(--clr-red)"
        btnTopBg="transparent"
        btnBottomColor="var(--clr-red)"
        btnBottomBg="transparent"
        cardBorderRadius="0px"
        imageAlign="center"
      >
        <!-- H1 Headline -->
        <!-- <template v-slot:headline> Team </template> -->
        <!-- Teaser -->
        <template v-slot:teaser>
          <div v-html="$texte.cast.teaser"></div>
        </template>
        <!-- Hidden Maincontent -->
        <div>
          <div v-html="$texte.cast.protagonisten"></div>
          <br />
          <div v-html="$texte.cast.crew"></div>
        </div>
      </MobileExpandableCard>
    </div>
    <!-- Ende -->

    <div class="mob-cite" :class="$mq">
      <div class="cite-image-2">
        <img src="@/assets/images/allgemein/cite_sign.png" alt="" />
      </div>
      <div class="text">
        <BaseCitesFade2 class="" :class="$mq" />
      </div>
    </div>
  </div>
</template>

<script>
import Smalltext from './../website_elements/Text.vue'

export default {
  inject: ['kinostart'],
  components: {
    Smalltext,
  },
}
</script>

<style lang="scss" scoped>
.stoerer-wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  padding-block: 1em;
  .mobile__stoerer {
    padding-block: 1em;
    max-width: 151px;
  }
}
.mob-cite {
  padding: 2em;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    align-self: flex-start;
  }
  .text {
    margin-left: 20px;
    margin-top: 10px;
    font-size: 1.4rem;
    width: 100% !important;
    &.sm {
      .text {
        font-size: 1rem;
        .author {
          font-size: 0.6rem;
        }
      }
    }
  }
}
.mob-card-headline {
  position: relative;
  width: 100%;
  height: 1px;
  background-color: white;
  .text {
    position: absolute;
    left: 50%;
    top: 1px;
    transform: translateX(-50%);
    padding: 0.2em 1em;
    display: inline-block;
    z-index: 899;
    color: white;
    text-transform: uppercase;
    font-size: 1.6rem;
    font-weight: 900;
    background-color: var(--clr-red);
  }
}
.mobile__dvd {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: #171317;
  padding-top: 2em;
  a {
    display: block;
    margin: 5px;
  }
}
.sizzle-1 {
  background-color: #171317;
  padding-block: 2em;
}
.mob-fotos {
  padding-block: 2em;
  img {
    width: 100%;
  }
}
</style>
